export default {
  // ========== Common Currency Unit ==========
  'currency.yuan': 'CNY',

  // ========== Profit Receiver ==========
  'button.profitReceiver.create': 'Create Profit Receiver',
  'error.profitReceiver.loadListFailed': 'Failed to load profit receiver list',
  'error.profitReceiver.deleteFailed': 'Failed to delete profit receiver',
  'error.profitReceiver.operationFailed': 'Profit receiver operation failed',
  'table.profitReceiver.name': 'Receiver Name',
  'table.profitReceiver.ownerType': 'Owner Type',
  'table.profitReceiver.ownerName': 'Owner',
  'table.profitReceiver.phone': 'Phone',
  'table.profitReceiver.wxReceiverAccount': 'WeChat Merchant No.',
  'table.profitReceiver.aliReceiverAccount': 'Alipay Account',
  'table.profitReceiver.wxBound': 'WeChat Binding Status',
  'table.profitReceiver.aliBound': 'Alipay Binding Status',
  'status.bound.bound': 'Bound',
  'status.bound.notBound': 'Not Bound',
  'status.bound.notConfigured': 'Not Configured',
  'modal.profitReceiver.deleteTitle': 'Delete Profit Receiver',
  'modal.profitReceiver.deleteContent': 'Are you sure to delete this profit receiver?',
  'modal.profitReceiver.updateTitle': 'Update Profit Receiver',
  'modal.profitReceiver.createTitle': 'Create Profit Receiver',
  'form.profitReceiver.brandId': 'Brand',
  'form.profitReceiver.ownerType': 'Owner Type',
  'form.profitReceiver.ownerId': 'Store',
  'form.profitReceiver.name': 'Receiver Name',
  'form.profitReceiver.phone': 'Phone',
  'form.profitReceiver.password': 'Initial Password',
  'form.profitReceiver.phoneTooltip': 'Used for fund account login',
  'form.profitReceiver.wxReceiverAccount': 'WeChat Receiver Merchant No.',
  'form.profitReceiver.wxReceiverName': 'WeChat Receiver Name',
  'form.profitReceiver.wxRelationType': 'WeChat Relation Type',
  'form.profitReceiver.aliReceiverAccount': 'Alipay Receiver Account',
  'form.profitReceiver.aliReceiverName': 'Alipay Receiver Name',
  'form.profitReceiver.wxBoundStatus': 'WeChat Binding Status',
  'form.profitReceiver.aliBoundStatus': 'Alipay Binding Status',
  'form.profitReceiver.autoBindingTip': 'Tip: After filling in WeChat/Alipay receiver information, the system will automatically call the platform interface to bind profit sharing relationship. Binding failure will not affect saving, you can check the binding status in the list.',
  'validation.profitReceiver.brandIdRequired': 'Please select brand',
  'validation.profitReceiver.ownerIdRequired': 'Please select store',
  'validation.profitReceiver.nameRequired': 'Please enter receiver name',
  'validation.profitReceiver.phoneRequired': 'Please enter phone number',
  'modal.profitReceiver.accountCreated': 'Fund Account Created',
  'modal.profitReceiver.accountInfo': 'A fund account has been created for this receiver. Use the following credentials to login and view profit sharing records:',
  'modal.profitReceiver.passwordTip': '⚠️ Please keep the initial password safe. You can change it after login.',

  // ========== Brand Profit Preset ==========
  'button.brandProfitPreset.create': 'Create Brand Profit Preset',
  'error.brandProfitPreset.loadListFailed': 'Failed to load brand profit preset list',
  'error.brandProfitPreset.deleteFailed': 'Failed to delete brand profit preset',
  'error.brandProfitPreset.operationFailed': 'Brand profit preset operation failed',
  'table.brandProfitPreset.receiverName': 'Receiver',
  'table.brandProfitPreset.sharingType': 'Sharing Type',
  'table.brandProfitPreset.fixedAmount': 'Fixed Amount',
  'table.brandProfitPreset.ratio': 'Sharing Ratio',
  'modal.brandProfitPreset.deleteTitle': 'Delete Brand Profit Preset',
  'modal.brandProfitPreset.deleteContent': 'Are you sure to delete this brand profit preset?',
  'modal.brandProfitPreset.updateTitle': 'Update Brand Profit Preset',
  'modal.brandProfitPreset.createTitle': 'Create Brand Profit Preset',
  'form.brandProfitPreset.brandId': 'Brand',
  'form.brandProfitPreset.receiverId': 'Profit Receiver',
  'form.brandProfitPreset.sharingType': 'Sharing Type',
  'form.brandProfitPreset.fixedAmount': 'Fixed Amount',
  'form.brandProfitPreset.fixedAmountTooltip': 'Fixed amount per order (unit: CNY)',
  'form.brandProfitPreset.ratio': 'Sharing Ratio',
  'form.brandProfitPreset.ratioTooltip': 'Percentage of order amount, e.g., 10 means 10%',
  'validation.brandProfitPreset.brandIdRequired': 'Please select brand',
  'validation.brandProfitPreset.receiverIdRequired': 'Please select profit receiver',
  'validation.brandProfitPreset.fixedAmountRequired': 'Please enter fixed amount',
  'validation.brandProfitPreset.ratioRequired': 'Please enter sharing ratio',

  // ========== Store Profit Rule ==========
  'button.storeProfitRule.create': 'Create Store Profit Rule',
  'error.storeProfitRule.loadListFailed': 'Failed to load store profit rule list',
  'error.storeProfitRule.deleteFailed': 'Failed to delete store profit rule',
  'error.storeProfitRule.operationFailed': 'Store profit rule operation failed',
  'table.storeProfitRule.ownerType': 'Owner Type',
  'table.storeProfitRule.receiverName': 'Receiver',
  'table.storeProfitRule.sharingType': 'Sharing Type',
  'table.storeProfitRule.fixedAmount': 'Fixed Amount',
  'table.storeProfitRule.ratio': 'Sharing Ratio',
  'modal.storeProfitRule.deleteTitle': 'Delete Store Profit Rule',
  'modal.storeProfitRule.deleteContent': 'Are you sure to delete this store profit rule?',
  'modal.storeProfitRule.updateTitle': 'Update Store Profit Rule',
  'modal.storeProfitRule.createTitle': 'Create Store Profit Rule',
  'form.storeProfitRule.brandId': 'Brand',
  'form.storeProfitRule.storeId': 'Store',
  'form.storeProfitRule.ownerType': 'Owner Type',
  'form.storeProfitRule.receiverId': 'Profit Receiver',
  'form.storeProfitRule.sharingType': 'Sharing Type',
  'form.storeProfitRule.fixedAmount': 'Fixed Amount',
  'form.storeProfitRule.fixedAmountTooltip': 'Fixed amount per order (unit: CNY)',
  'form.storeProfitRule.ratio': 'Sharing Ratio',
  'form.storeProfitRule.ratioTooltip': 'Percentage of order amount, e.g., 10 means 10%',
  'validation.storeProfitRule.brandIdRequired': 'Please select brand',
  'validation.storeProfitRule.storeIdRequired': 'Please select store',
  'validation.storeProfitRule.receiverIdRequired': 'Please select profit receiver',
  'validation.storeProfitRule.fixedAmountRequired': 'Please enter fixed amount',
  'validation.storeProfitRule.ratioRequired': 'Please enter sharing ratio',

  // ========== Profit Sharing ==========
  'button.common.view': 'View',
  'button.profitSharing.retry': 'Retry',
  'error.profitSharing.loadListFailed': 'Failed to load profit sharing list',
  'error.profitSharing.loadDetailFailed': 'Failed to load profit sharing detail',
  'message.profitSharing.retrySuccess': 'Retry sharing successfully',
  'message.profitSharing.retryConfirm': 'Are you sure to retry this sharing?',
  'table.profitSharing.sharingNo': 'Sharing No.',
  'table.profitSharing.orderNo': 'Order No.',
  'table.profitSharing.payChannel': 'Pay Channel',
  'table.profitSharing.transactionId': 'Transaction ID',
  'table.profitSharing.totalAmount': 'Order Amount',
  'table.profitSharing.totalSharingAmount': 'Total Sharing Amount',
  'table.profitSharing.receiverCount': 'Receiver Count',
  'table.profitSharing.sharingStatus': 'Sharing Status',
  'table.profitSharing.sharingTime': 'Sharing Time',
  'table.profitSharing.failureReason': 'Failure Reason',
  'table.profitSharing.receiverName': 'Receiver',
  'table.profitSharing.receiverAccount': 'Receiver Account',
  'table.profitSharing.sharingType': 'Sharing Type',
  'table.profitSharing.sharingRatio': 'Sharing Ratio',
  'table.profitSharing.sharingRule': 'Sharing Rule',
  'table.profitSharing.sharingAmount': 'Actual Amount',
  'table.profitSharing.detailStatus': 'Detail Status',
  'modal.profitSharing.detailTitle': 'Profit Sharing Detail',
  'modal.profitSharing.detailsTitle': 'Sharing Details',

  // ========== Enums ==========
  // Owner Type
  'enum.ownerType.brand': 'Brand Level',
  'enum.ownerType.store': 'Store Level',
  // Sharing Type
  'enum.sharingType.fixed': 'Fixed Amount',
  'enum.sharingType.ratio': 'By Ratio',
  'enum.sharingType.mixed': 'Mixed Mode',
  // WeChat Relation Type
  'enum.wxRelationType.supplier': 'Supplier',
  'enum.wxRelationType.distributor': 'Distributor',
  'enum.wxRelationType.serviceProvider': 'Service Provider',
  'enum.wxRelationType.platform': 'Platform',
  'enum.wxRelationType.others': 'Others',
  // Pay Channel
  'enum.payChannel.wechat': 'WeChat Pay',
  'enum.payChannel.alipay': 'Alipay',
  // Sharing Status
  'enum.sharingStatus.pending': 'Pending',
  'enum.sharingStatus.processing': 'Processing',
  'enum.sharingStatus.success': 'Success',
  'enum.sharingStatus.partialSuccess': 'Partial Success',
  'enum.sharingStatus.failed': 'Failed',

  // ========== Profit Sharing Return ==========
  'button.refund.viewProfitSharingReturns': 'View Return Records',
  'error.profitSharingReturn.loadListFailed': 'Failed to load profit sharing return list',
  'error.profitSharingReturn.loadDetailFailed': 'Failed to load profit sharing return detail',
  'table.profitSharingReturn.returnNo': 'Return No.',
  'table.profitSharingReturn.refundNo': 'Refund No.',
  'table.profitSharingReturn.sharingNo': 'Sharing No.',
  'table.profitSharingReturn.orderNo': 'Order No.',
  'table.profitSharingReturn.payChannel': 'Pay Channel',
  'table.profitSharingReturn.totalReturnAmount': 'Total Return Amount',
  'table.profitSharingReturn.receiverCount': 'Receiver Count',
  'table.profitSharingReturn.returnStatus': 'Return Status',
  'table.profitSharingReturn.returnTime': 'Return Time',
  'table.profitSharingReturn.failureReason': 'Failure Reason',
  'table.profitSharingReturn.receiverName': 'Receiver',
  'table.profitSharingReturn.receiverAccount': 'Receiver Account',
  'table.profitSharingReturn.originalSharingAmount': 'Original Sharing Amount',
  'table.profitSharingReturn.returnAmount': 'Return Amount',
  'table.profitSharingReturn.thirdPartyReturnNo': 'Third Party Return No.',
  'table.profitSharingReturn.detailStatus': 'Detail Status',
  'modal.profitSharingReturn.detailTitle': 'Profit Sharing Return Detail',
  'modal.profitSharingReturn.detailsTitle': 'Return Details',
  // Return Status
  'enum.returnStatus.pending': 'Pending',
  'enum.returnStatus.processing': 'Processing',
  'enum.returnStatus.success': 'Success',
  'enum.returnStatus.partialSuccess': 'Partial Success',
  'enum.returnStatus.failed': 'Failed',

  // ========== Fund Account ==========
  'error.fundAccount.loadListFailed': 'Failed to load profit sharing records',
  'error.fundAccount.loadProfileFailed': 'Failed to load account profile',
  'error.fundAccount.loadStatisticsFailed': 'Failed to load statistics',
  'table.fundAccount.statistics': 'Statistics',
  'table.fundAccount.totalAmount': 'Total Amount',
  'table.fundAccount.totalCount': 'Total Count',
  'table.fundAccount.monthAmount': 'Month Amount',
  'table.fundAccount.monthCount': 'Month Count',
  'table.fundAccount.profile': 'Account Profile',
  'table.fundAccount.phone': 'Phone',
  'table.fundAccount.brandName': 'Brand',
  'table.fundAccount.receivers': 'Associated Receivers',
  'table.fundAccount.receiverName': 'Receiver Name',
  'table.fundAccount.receiverStatus': 'Status',
  'modal.fundAccount.detailTitle': 'Profit Sharing Detail',
  'modal.fundAccount.detailsTitle': 'Sharing Details',
  'enum.receiverStatus.disabled': 'Disabled',
  'enum.receiverStatus.enabled': 'Enabled',
};
